import React from 'react';
import clsx from 'clsx';

// TODO delete this file
export const Cell: React.FC<React.PropsWithChildren & React.HTMLAttributes<HTMLDivElement>> = ({
  children,
  className,
  ...rest
}) => (
  <div
    {...rest}
    className={clsx('w-full md:w-1/2 lg:w-1/3 xl:w-1/3 2xl:w-1/4 px-4 mb-4 md:mb-8', className)}
    role="griditem"
  >
    {children}
  </div>
);

export const Grid: React.FC<React.PropsWithChildren> = ({ children }) => {
  if (!children) {
    return null;
  }

  return (
    <div className="container">
      <div className="flex flex-wrap -mx-4" role="grid">
        {children}
      </div>
    </div>
  );
};
